import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
export const ArrowLeft = props => {
    return (React.createElement(SvgIcon, Object.assign({}, props),
        React.createElement("path", { d: "M15,5.58578644 L21.7071068,12.2928932 L15,19 L13.5857864,17.5857864 L17.8778932,13.2927864 L2.29289322,13.2928932 L2.29289322,11.2928932 L17.8778932,11.2927864 L13.5857864,7 L15,5.58578644 Z", id: "Combined-Shape", transform: "translate(12.000000, 12.292893) rotate(-180.000000) translate(-12.000000, -12.292893)" })));
};
export default ArrowLeft;
